"use strict";

exports.__esModule = true;
exports.getLivestreamEmbedUrl = exports.isLivestreamEmbedUrl = exports.getSportnetVideoEmbedUrl = exports.getIdnesEmbedUrl = exports.getTa3EmbedUrl = exports.getDalilymotionEmbedUrl = exports.getVimeoEmbedUrl = exports.getYoutubeEmbedUrl = void 0;

var tslib_1 = require("tslib");

function getYoutubeEmbedUrl(url) {
  var re = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  var match = url.match(re);

  if (match && match[2].length === 11) {
    return "//www.youtube.com/embed/" + match[2];
  }

  return null;
}

exports.getYoutubeEmbedUrl = getYoutubeEmbedUrl;

function getVimeoEmbedUrl(url) {
  var re = /^.*(www\.)?(player\.)?vimeo.com\/(video\/)?(\d+)(?:|\/\?)/;
  var match = url.match(re);

  if (match) {
    return "//player.vimeo.com/video/" + match[4];
  }

  return null;
}

exports.getVimeoEmbedUrl = getVimeoEmbedUrl;

function getDalilymotionEmbedUrl(url) {
  var re = /^.*(dailymotion\.com(?:\/video|\/hub|\/embed\/video)|dai\.ly)\/([0-9a-z]+)(?:[\-_0-9a-zA-Z]+#video=([a-z0-9]+))?/;
  var match = url.match(re);

  if (match) {
    return "//dailymotion.com/embed/video/" + match[2];
  }

  return null;
}

exports.getDalilymotionEmbedUrl = getDalilymotionEmbedUrl;

function getTa3EmbedUrl(url) {
  var re = /^.*ta3.com\/embed\/([\-_0-9a-zA-Z]+\.htm[l]?)/;
  var match = url.match(re);

  if (match) {
    return "//www.ta3.com/embed/" + match[1];
  }

  return null;
}

exports.getTa3EmbedUrl = getTa3EmbedUrl;

function getIdnesEmbedUrl(url) {
  var re = /^.*tv.idnes.cz\/((.+)\/([a-zA-Z0-9-]+)\.([A-Za-z0-9_]+)|((embed.aspx)\?idvideo=([A-Za-z0-9_]+)(&idrubriky=([A-Za-z0-9_-]+))?))/;
  var match = url.match(re);

  if (match) {
    if (match[6] && match[6] === 'embed.aspx') {
      return url;
    }

    return "//tv.idnes.cz/embed.aspx?idvideo=" + match[4];
  }

  return null;
}

exports.getIdnesEmbedUrl = getIdnesEmbedUrl;

function getSportnetVideoEmbedUrl(url) {
  var re = /^.*video\.sportnet\.online\/embed\/[\w\d]{24}$/;
  var match = url.match(re);

  if (match) {
    return url;
  }

  return null;
}

exports.getSportnetVideoEmbedUrl = getSportnetVideoEmbedUrl;

function isLivestreamEmbedUrl(url) {
  var re = /^.*livestream\.com\/.+/;
  return !!url.match(re);
}

exports.isLivestreamEmbedUrl = isLivestreamEmbedUrl;

function getLivestreamEmbedUrl(url, cmsApi) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    var response, e_1;
    return tslib_1.__generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!isLivestreamEmbedUrl(url)) return [3
          /*break*/
          , 4];
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , cmsApi.parseLivestreamUrl({
            url: url
          })];

        case 2:
          response = _a.sent();
          return [2
          /*return*/
          , response.embedPlayerUrl];

        case 3:
          e_1 = _a.sent();
          return [3
          /*break*/
          , 4];

        case 4:
          return [2
          /*return*/
          , null];
      }
    });
  });
}

exports.getLivestreamEmbedUrl = getLivestreamEmbedUrl;